export default {"src":"/_next/static/media/loan-amount.80cae24b.svg","height":25,"width":25};